import React, { useState } from 'react'
import Layouts from '../../Layouts/Layouts'
import { StyledMainPageRightSection } from '../dashboard/style.dashboard'
// import { AddButton, PackageBody, PackageCard, PackageImage, PackagesGrid, PackageTitle, PageHeader, PageTitle, PageWrapper, SectionTitle } from './style.hajjumrahpackages'
import {
  PageWrapper,
  PageHeader,
  PageTitle,
  AddButton,
  SectionTitle,
  PackagesGrid,
  PackageCard,
  PackageImage,
  PackageBody,
  PackageTitle,
  PackageMeta,
  PackagePrice,
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseBtn,
  ModalBody,
  FormGrid,
  Input,
  Select,
  TextArea,
  ModalFooter,
  PrimaryBtn,
  SecondaryBtn,
} from "./style.hajjumrahpackages";


const HajjUmrahPackages = () => {
   const [open, setOpen] = useState(false);

  const domesticPackages = [
    {
      title: "Kerala Backwater Bliss",
      meta: "Kerala • 6 Days / 5 Nights",
      price: "₹22,000",
      image:
        "https://images.unsplash.com/photo-1502082553048-f009c37129b9",
    },
  ];
  return (
    <>
    <Layouts>

      
        <StyledMainPageRightSection>
          <PageWrapper>
        <PageHeader>
          <PageTitle>Tour Packages</PageTitle>
          <AddButton onClick={() => setOpen(true)}>+ Add Package</AddButton>
        </PageHeader>

        {/* Domestic */}
        <SectionTitle>Domestic Packages</SectionTitle>
        <PackagesGrid>
          {domesticPackages.map((pkg, i) => (
            <PackageCard key={i}>
              <PackageImage src={pkg.image} />
              <PackageBody>
                <PackageTitle>{pkg.title}</PackageTitle>
                <PackageMeta>{pkg.meta}</PackageMeta>
                <PackagePrice>{pkg.price}</PackagePrice>
              </PackageBody>
            </PackageCard>
          ))}
        </PackagesGrid>

        {/* International */}
        <SectionTitle>International Packages</SectionTitle>
        <PackagesGrid>
          {/* Empty state for now */}
        </PackagesGrid>
      </PageWrapper>

      {/* Modal */}
      {open && (
        <ModalOverlay>
          <ModalContainer>
            <ModalHeader>
              <ModalTitle>Add Tour Package</ModalTitle>
              <CloseBtn onClick={() => setOpen(false)}>×</CloseBtn>
            </ModalHeader>

            <ModalBody>
              <FormGrid>
                <Input placeholder="Package Name" />
                <Select>
                  <option>Domestic</option>
                  <option>International</option>
                </Select>
                <Input placeholder="Destination" />
                <Input placeholder="Duration (Eg: 6 Days / 5 Nights)" />
                <Input placeholder="Price" />
                <Input placeholder="Offer Price (optional)" />
                <Input placeholder="Thumbnail Image URL" />
                <TextArea placeholder="Package Description" />
                <Input placeholder="Package Name" />
                <Select>
                  <option>Domestic</option>
                  <option>International</option>
                </Select>
                <Input placeholder="Destination" />
                <Input placeholder="Duration (Eg: 6 Days / 5 Nights)" />
                <Input placeholder="Price" />
                <Input placeholder="Offer Price (optional)" />
                <Input placeholder="Thumbnail Image URL" />
                <TextArea placeholder="Package Description" />
              </FormGrid>
            </ModalBody>

            <ModalFooter>
              <SecondaryBtn onClick={() => setOpen(false)}>
                Cancel
              </SecondaryBtn>
              <PrimaryBtn>Add Package</PrimaryBtn>
            </ModalFooter>
          </ModalContainer>
        </ModalOverlay>
      )}
        </StyledMainPageRightSection>
    </Layouts>
     
    </>
  )
}

export default HajjUmrahPackages
